module.exports = {"fb_lang":"ko_KR","mapCenter":{"lat":"37.5650172","lng":"126.8494663"},"geocomplete_country":"kr","PHONE_REGEX":"^\\d{9,11}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","ko-KR":{"blank_field":"해당 항목을 입력해주세요","incorrect_email":"해당 항목을 입력해주세요","error_message_signup_email_used":"이미 등록된 이메일입니다.","error_message_signup_phone_taken":"이미 등록된 번호입니다."}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/kr/scripts/components/setting.json
// module id = 856
// module chunks = 0 1 2 3 4 5